const terminal = new Set(["COMPLETED", "CANCELLED", "EXPIRED", "FAILED"]);

export function orderNeedsReconciliation(status: string, confirmedAt: string | null, now = Date.now()) {
  if (terminal.has(status)) return false;
  const timestamp = confirmedAt ? Date.parse(confirmedAt) : NaN;
  return status === "UNKNOWN" || !Number.isFinite(timestamp) || now - timestamp > 120_000;
}
